import { render, staticRenderFns } from "./CreateGoodsDialog.vue?vue&type=template&id=6fe9029b&scoped=true&lang=pug&"
import script from "./CreateGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateGoodsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGoodsDialog.vue?vue&type=style&index=0&id=6fe9029b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe9029b",
  null
  
)

export default component.exports